export const environment = {
    production: false,
    baseUrl: 'https://assinar.homolog.api.dentaloffice.com.br',
    frontUrl: 'https://assinar.homolog.dentaloffice.com.br/',
    amplitudeApiKey: 'e7fdde7b75bc72f31170499d0fefeb93',
    mixPanelApiKey: 'd4ccbbcbe4003e28aec474f242366be0'
};

